<h1 mat-dialog-title i18n="@@app.help.probability.title">Probabilidades</h1>
<div mat-dialog-content class="table-container">
  <table mat-table [dataSource]="dataSource" class="table">
    <ng-container matColumnDef="clasification">
      <th mat-header-cell *matHeaderCellDef i18n="@@app.help.probability.head.clasification">Clasificación</th>
      <td mat-cell *matCellDef="let element">{{ element.clasification }}</td>
    </ng-container>
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="text-center">{{ element.value }}</td>
    </ng-container>
    <ng-container matColumnDef="frequency">
      <th mat-header-cell *matHeaderCellDef i18n="@@app.help.probability.head.frecuency">Frecuencia</th>
      <td mat-cell *matCellDef="let element">{{ element.frequency }}</td>
    </ng-container>
    <ng-container matColumnDef="example">
      <th mat-header-cell *matHeaderCellDef i18n="@@app.help.probability.head.example">Ejemplo</th>
      <td mat-cell *matCellDef="let element">{{ element.example }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div mat-dialog-actions class="btn-container flex f-ai--center f-jc--center">
  <button mat-raised-button mat-dialog-close i18n="@@app.help.probability.close">Cerrar</button>
</div>
